import { format } from "date-fns";
import {
  QualityEventAnswers,
  QualityEventField,
  QualityEventRecord,
  qualityEventRows,
} from "src/types/quality-events";
import { isQualityEventConditionMet } from "./quality-event-conditions";

export const getQualityEventStatistics = (records: QualityEventRecord[]) => {
  const open = records.filter((record) => record.status !== "CLOSED");
  const today = format(new Date(), "yyyy-MM-dd");
  const isPastDue = (value: unknown) =>
    typeof value === "string" && value !== "" && value < today;
  const hasOverdueDeadline = (
    fields: QualityEventField[],
    answers: QualityEventAnswers,
    allAnswers: QualityEventAnswers
  ): boolean => {
    const scope = { ...allAnswers, ...answers };
    return fields.some((field) => {
      if (!isQualityEventConditionMet(field.showWhen, scope)) return false;
      if (field.type === "repeatable") {
        return qualityEventRows(answers[field.key]).some((row) =>
          hasOverdueDeadline(field.fields, row.answers, scope)
        );
      }
      return (
        field.type === "date" &&
        !!field.deadline &&
        isPastDue(answers[field.key]) &&
        !field.deadline.resolvedWhen?.some((condition) =>
          isQualityEventConditionMet(condition, scope)
        )
      );
    });
  };
  return {
    open: open.length,
    inReview: records.filter((record) => record.status === "IN_REVIEW").length,
    closed: records.length - open.length,
    overdue: open.filter((record) => {
      if (
        Object.values(record.steps).some(
          (step) => !step.completedAt && isPastDue(step.dueDate)
        )
      ) {
        return true;
      }
      const allAnswers = Object.assign(
        {},
        ...Object.values(record.steps).map((step) => step.answers)
      );
      return record.definition.definition.steps.some((step) =>
        hasOverdueDeadline(
          step.fields,
          record.steps[step.key]?.answers ?? {},
          allAnswers
        )
      );
    }).length,
  };
};
